import { AxiosInstance } from "axios";
import { Iagenda } from "../common";

export const ActivityService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrlMasterdata = "api/masterdata";
  const apiBaseUrlAgenda = "api/agenda";
  return {
    getMasterdataAgenda: async () => {
      return await axiosInstance
        .get(`${apiBaseUrlMasterdata}/agenda`)
        .then((result) => result.data);
    },
    createAgenda: async (data: Iagenda) => {
      return await axiosInstance
        .post(`${apiBaseUrlAgenda}`, data)
        .then((result) => result.data);
    },
  };
};
